import { html, css, nothing } from "lit";
import { OutDesignNodeElement } from "./OutDesignNodeElement";
import { customElement } from "lit/decorators.js";

@customElement("od-block")
export class OutDesignBlockElement extends OutDesignNodeElement {
  level : number | undefined;

  static styles = [OutDesignNodeElement.styles,
    css`
    :host {
      display: block;
      border-left-width: 3px;
      border-left-style: solid;
      border-left-color: #8f01773d;
      padding-left: .5rem;
      margin: .25rem 0;
    }
    
    :host(:not(:hover):not([structureViewEnabled])) {
      border-left-color: transparent;
    }

    [data-role=meta] {
      font-size: 0.7rem;
      color: #8f0177;
      font-family: monospace;
    }

    :host(:not(:hover):not([structureviewenabled])) [data-role=meta] {
      opacity: 0;
    }

    :host([originalStylesEnabled]) ::slotted(h1),
    :host([originalStylesEnabled]) ::slotted(h2),
    :host([originalStylesEnabled]) ::slotted(h3),
    :host([originalStylesEnabled]) ::slotted(h4),
    :host([originalStylesEnabled]) ::slotted(h5),
    :host([originalStylesEnabled]) ::slotted(h6) {
      font-weight: inherit;
      font-size: inherit;
    }
  `];

  render() {
    return html`
      <div data-role="meta">
        <od-meta
          .type=${this.type}
          .attr=${this.attr}
          .data=${this.data}
        ></od-meta>
      </div>

      <div data-role="wrapper" data-indesign-style=${this.originalInDesignStyle || nothing}>
        <slot></slot>
      </div>
    `;
  }
}